module.exports = __webpack_public_path__ + "static/media/og.75df06ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/og.png
// module id = 95
// module chunks = 0